import { Popper } from "@mui/material";
import { ArrowDown2, Chart2, SearchNormal1 } from "iconsax-react";
import React, { ReactNode, SetStateAction, useRef } from "react";
import FilterCard from "../common/FilterCard";
import Button from "../common/Button";
import { ChevronRight } from "@mui/icons-material";
import { CheckboxGroup } from "../common/CustomCheckbox";

interface FilterProps {
  handleOpenCalendar?: () => void;
  activeTimeLine: string;
  setActiveTimeLine: SetStateAction<any>;
  handleTimeLine?: () => void;
  showMetrics?: boolean;
  showFilter?: boolean;
  showTimeLine?: boolean;
  metricsTitle?: string;
  handleMetricsCheckboxChange?: (value: string, isChecked: boolean) => void;
  metricsSelectedValues?: string[];
  setMetricsSelectedValues?: SetStateAction<any>;
  metricsOptions?: { label: string; value: string }[];
  children?: ReactNode;
}

function Filters({
  handleOpenCalendar,
  activeTimeLine,
  setActiveTimeLine,
  handleTimeLine,
  showMetrics = false,
  showTimeLine = true,
  showFilter = false,
  metricsTitle,
  handleMetricsCheckboxChange,
  metricsSelectedValues,
  setMetricsSelectedValues,
  metricsOptions,
  children,
}: FilterProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorMetricsEl, setMetricsAnchorEl] = React.useState<null | HTMLElement>(null);
  const popperRef = useRef<HTMLDivElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const handleMetricsClick = (event: React.MouseEvent<HTMLElement>) => {
    setMetricsAnchorEl(anchorMetricsEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const openMetrics = Boolean(anchorMetricsEl);
  const metrics = openMetrics ? "simple-popper" : undefined;
  const id = open ? "simple-popper" : undefined;

  const timeLineOptions = [
    {
      value: "today",
      text: "Today",
    },
    {
      value: "week",
      text: "This Week",
    },
    {
      value: "month",
      text: "This Month",
    },
    // {
    //   value: "quarter",
    //   text: "This Quarter",
    // },
  ];

  const handleClosePopper = (event: MouseEvent) => {
    if (popperRef.current && !popperRef.current.contains(event.target as Node) && (open || openMetrics)) {
      setAnchorEl(null);
      setMetricsAnchorEl(null);
    }
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClosePopper);
    return () => {
      document.removeEventListener("mousedown", handleClosePopper);
    };
  }, [open, openMetrics]);

  return (
    <>
      <div className="w-1/2 flex gap-2 justify-end relative">
        {showMetrics && (
          <button
            aria-describedby={metrics}
            onClick={handleMetricsClick}
            type="button"
            className="w-2/5 text-primary bg-white hover:bg-slate-300 font-medium rounded-lg text-sm px-3 py-2 text-center inline-flex items-center me-2 dark:bg-white dark:hover:bg-salte-600 h-[48px]"
          >
            <Chart2 className="mr-2" />
            Metrics
          </button>
        )}
        {showFilter && (
          <button
            type="button"
            className="justify-between w-1/5 text-primary bg-white hover:bg-slate-300 font-medium rounded-lg text-sm px-3 py-2 text-center inline-flex items-center me-2 dark:bg-white dark:hover:bg-salte-600 h-[48px]"
          >
            Filter
            <ArrowDown2 />
          </button>
        )}

        {showTimeLine && (
          <button
            // onClick={handleOpenCalendar}
            aria-describedby={id}
            onClick={handleClick}
            type="button"
            className="capitalize justify-between w-2/5 text-primary bg-white hover:bg-slate-300 font-medium rounded-lg text-sm px-3 py-2.5 text-center inline-flex items-center me-2 dark:bg-white dark:hover:bg-salte-600 "
          >
            {timeLineOptions.find((option) => option?.value === activeTimeLine)?.text || "Custom Date Range"}
            <ArrowDown2 />
          </button>
        )}

        {children}
      </div>
      <Popper id={id} open={open} anchorEl={anchorEl}>
        <div ref={popperRef}>
          <FilterCard>
            <h4 className="text-primary text-lg font-semibold">Timeline</h4>
            <ul className="mb-2">
              {timeLineOptions.map((option) => {
                return (
                  <li
                    className={`py-4 px-3 text-primary font-medium  cursor-pointer hover:bg-slate-200 rounded-md ${activeTimeLine === option.value ? "bg-grey200" : ""} `}
                    onClick={() => {
                      setActiveTimeLine(option.value);
                    }}
                  >
                    {option.text}
                  </li>
                );
              })}
              <li
                className={`py-4 px-3 text-primary font-medium  cursor-pointer hover:bg-slate-200 rounded-md ${activeTimeLine === "custom" ? "bg-grey200" : ""} `}
                onClick={() => {
                  if (handleOpenCalendar) handleOpenCalendar();
                  setActiveTimeLine("custom");
                }}
              >
                Custom Date Range <ChevronRight />
              </li>
            </ul>
            <Button
              text="Apply"
              onSubmit={() => {
                if (handleTimeLine) handleTimeLine();
                setAnchorEl(null);
              }}
            />
          </FilterCard>
        </div>
      </Popper>
      <Popper id={metrics} open={openMetrics} anchorEl={anchorMetricsEl}>
        <div ref={popperRef}>
          <FilterCard>
            <div className="divide-y divide-[#071839] ">
              <div className="flex justify-center gap-3 text-primary pb-4">
                <Chart2 className=" text-primary" />
                <span className="text-primary font-bold">Metrics</span>
              </div>
              <h6 className="text-grey200 pt-2 font-semibold">Select the data you will like</h6>
            </div>
            <div>
              <h6 className="text-grey200 pt-2 font-semibold">{metricsTitle}</h6>
              <CheckboxGroup
                selectedValues={metricsSelectedValues ? metricsSelectedValues : [""]}
                setSelectedValues={setMetricsSelectedValues}
                handleCheckboxChange={handleMetricsCheckboxChange}
                options={metricsOptions ? metricsOptions : [{ label: "", value: "" }]}
              />
            </div>
          </FilterCard>
        </div>
      </Popper>

      <div className="absolute top-44 bottom-0 right-auto left-auto z-10"></div>
    </>
  );
}

export default Filters;
